import React from "react";
import { Button } from "@mui/material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { autoSizeOptionsForDataGrid } from "constants/componentsConstants";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { useGlobalContext } from "context/GlobalContext";
import { useFinishContext } from "../context";
import { finishOperationsList } from "../constants/finish.constants";
import { finishListColumnsS } from "../responsiveData/finishListColumnsS";
import { finishListColumnsL } from "../responsiveData/finishListColumnsL";
import { FinishTopBanner } from "../components/FinishTopBanner";
import { confirmAction } from "utils/functions/confirmAction";
import { updateStatusFinishApi } from "API/apis/finish/updateStatusFinish";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { message } from "constants/responses/message";
import { dataGridState } from "constants/dataGridConstants";

export const FinishList = () => {
  const apiRef = useGridApiRef();
  const { setIsLoading, setSuccess, setError, isMobile } = useGlobalContext();
  const {
    list,
    setList,
    setCurrentOperationPage,
    setPreviewFinish,
    setReloadRequired,
  } = useFinishContext();
  const handleChangeStatus = async (id, currStatus) => {
    try {
      const confirmed = confirmAction(message.info.generalConfirmBoxMessage);
      if (!confirmed) {
        return;
      }
      setIsLoading(true);
      const { data, status } = await updateStatusFinishApi({
        status: !currStatus,
        id: id,
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setList(list);
      setSuccess(data?.message);
      setCurrentOperationPage(finishOperationsList.listFinish);
      setReloadRequired(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const handleEdit = (row) => {
    setPreviewFinish(row);
    setCurrentOperationPage(finishOperationsList.updateFinish);
  };
  const handleClearFilter = () => {
    apiRef.current.setFilterModel({ items: [] });
  };

  return (
    <>
      <PageTitle pageName={pageName.finish.list} />
      <FinishTopBanner
        finishOperationsParam={finishOperationsList.newFinish}
        buttonType="add"
      />
      <Button onClick={handleClearFilter}>Clear Filter</Button>
      <div style={{ width: "100%" }}>
        <DataGrid
          apiRef={apiRef}
          rows={list}
          getRowHeight={() => "auto"}
          disableRowSelectionOnClick
          autosizeOnMount
          columns={
            isMobile
              ? finishListColumnsS(handleEdit, handleChangeStatus)
              : finishListColumnsL(handleEdit, handleChangeStatus)
          }
          getRowId={(row) => row.id}
          autosizeOptions={autoSizeOptionsForDataGrid}
          initialState={dataGridState.initialState}
          pageSizeOptions={dataGridState.pageSizeOptions}
          columnVisibilityModel={{
            id: false,
          }}
        />
      </div>
    </>
  );
};
